import { boundaryListActionType } from "./actionTypes";

const initialState = {
    boudaryList:[]
}

 const boundaryReducer = (state = initialState,action)=>{
    switch (action.type) {
        case boundaryListActionType:
            return {
                ...state,boudaryList:action.payload
            }
        default:
           return state;
    }
}

export default boundaryReducer;

